var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g3, _g4, _g5, _g6, _g7, _path9, _path10, _path11, _path12, _path13, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaePhase2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 472.68 695.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-VAE-P2, .cls-2-VAE-P2, .cls-3-VAE-P2, .cls-4-VAE-P2, .cls-5-VAE-P2 {\n        stroke: #1071e5;\n      }\n\n      .cls-1-VAE-P2, .cls-6-VAE-P2 {\n        fill: #fff;\n      }\n\n      .cls-2-VAE-P2, .cls-3-VAE-P2, .cls-7-VAE-P2 {\n        fill: #1071e5;\n      }\n\n      .cls-8-VAE-P2 {\n        fill: rgba(255, 255, 255, 0);\n        stroke: rgba(0, 0, 0, 0);\n      }\n\n      .cls-3-VAE-P2 {\n        stroke-width: .05px;\n      }\n\n      .cls-6-VAE-P2, .cls-9-VAE-P2, .cls-7-VAE-P2, .cls-10-VAE-P2, .cls-11-VAE-P2 {\n        stroke-width: 0px;\n      }\n\n      .cls-9-VAE-P2 {\n        fill: #3a414a;\n      }\n\n      .cls-10-VAE-P2 {\n        fill: #e81313;\n      }\n\n      .cls-11-VAE-P2 {\n        fill: #008a0e;\n      }\n\n      .cls-4-VAE-P2 {\n        fill: none;\n      }\n\n      .cls-5-VAE-P2  {\n        fill: url(#linear-gradient-VAE-P2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-VAE-P2",
    x1: 1056.07,
    y1: 410.37,
    x2: 1056.07,
    y2: 241.72,
    gradientTransform: "translate(-884.44 736.76) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6db1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-VAE-P2",
    d: "m2.67,6.5C2.67,3.19,5.36.5,8.67.5h330.24c3.31,0,6,2.69,6,6v89.33c0,3.31-2.69,6-6,6H8.67c-3.31,0-6-2.69-6-6V6.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "n",
    className: "cls-9-VAE-P2",
    d: "m143.7,48.66c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87Zm-6.59-.75c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36Zm0,7.81c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    className: "cls-9-VAE-P2",
    d: "m156.88,46.48c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    className: "cls-9-VAE-P2",
    d: "m158.85,41.87v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    className: "cls-9-VAE-P2",
    d: "m169.37,44.38c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    className: "cls-9-VAE-P2",
    d: "m183.02,41.66c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p-2",
    "data-name": "p",
    className: "cls-9-VAE-P2",
    d: "m184.58,41.87v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    className: "cls-9-VAE-P2",
    d: "m196.26,44.38c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    className: "cls-9-VAE-P2",
    d: "m213.91,44.65c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04Zm-5.64,11.41c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-VAE-P2",
    d: "m173.77,102.83v46.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-VAE-P2",
    d: "m174.27,102.84h-1v-.5h1v.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-VAE-P2",
    d: "m173.77,163.64l-4.62-14.26h9.27l-4.65,14.26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-VAE-P2",
    d: "m172.14,575.04h-1v-22.5h1v22.5Zm0-51.84h-1v-28.54h1v28.54Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-VAE-P2",
    d: "m171.64,494.16l.5-.04v.54h-1v-.54l.5.04Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-VAE-P2",
    d: "m171.64,494.12l.52-.02v.58h-1.06v-.58l.54.02Zm-.48.5h.94v-.47h-.95v.47Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-VAE-P2",
    d: "m171.64,589.81l-4.64-14.27h9.27l-4.63,14.27Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-VAE-P2",
    d: "m171.64,591.42l-5.33-16.38h10.65l-5.32,16.38Zm-3.95-15.38l3.95,12.15,3.94-12.15h-7.89Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "u",
    className: "cls-11-VAE-P2",
    d: "m156.5,535.76v6.99h-2.31v-6.99l-6.45-9.85h2.51l5.09,8.01,5.09-8.01h2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    className: "cls-11-VAE-P2",
    d: "m165.53,542.76v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    className: "cls-11-VAE-P2",
    d: "m192.35,529.92c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "diamond1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-VAE-P2",
    d: "m166.25,329.04c3.4-1.67,7.38-1.67,10.77,0l160.36,79.02c1.46.73,2.06,2.51,1.33,3.97-.29.58-.75,1.04-1.33,1.33l-160.35,79.03c-3.4,1.67-7.38,1.67-10.77,0L5.89,413.36c-1.46-.73-2.06-2.51-1.33-3.97.29-.58.75-1.04,1.33-1.33l160.36-79.02Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "x",
    className: "cls-6-VAE-P2",
    d: "m112.54,379.57c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84Zm2.24,8.49c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "cls-6-VAE-P2",
    d: "m128.84,379.57c8.01-.48,14.67.54,14.46,8.28-.2,5.3-2.92,8.56-8.22,8.56h-6.25v-16.84Zm2.24,15.01c6.04.54,9.91-1.09,9.91-6.72s-4.07-6.86-9.91-6.45v13.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z",
    className: "cls-6-VAE-P2",
    d: "m148.66,381.47v6.25h9.37v1.9h-9.37v6.79h-2.24v-16.84h11.88v1.9h-9.64"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "A",
    className: "cls-6-VAE-P2",
    d: "m182.34,396.41l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    className: "cls-6-VAE-P2",
    d: "m193.14,383.24c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-2",
    "data-name": "B",
    className: "cls-6-VAE-P2",
    d: "m206.72,383.24c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    className: "cls-6-VAE-P2",
    d: "m217.52,393.22c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    className: "cls-6-VAE-P2",
    d: "m229.47,386.7c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "E",
    className: "cls-6-VAE-P2",
    d: "m96.86,437.48v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    className: "cls-6-VAE-P2",
    d: "m120.69,437.48l-3.46-5.3-3.53,5.3h-2.31l4.62-6.65-4.41-6.25h2.38l3.26,5.02,3.19-5.02h2.38l-4.35,6.25,4.62,6.65h-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G",
    className: "cls-6-VAE-P2",
    d: "m131.15,424.3c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-3",
    "data-name": "B",
    className: "cls-6-VAE-P2",
    d: "m143.71,424.3c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H",
    className: "cls-6-VAE-P2",
    d: "m157.02,426c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-2",
    "data-name": "C",
    className: "cls-6-VAE-P2",
    d: "m166.73,434.28c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    className: "cls-6-VAE-P2",
    d: "m179.08,435.03c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-3",
    "data-name": "C",
    className: "cls-6-VAE-P2",
    d: "m187.1,434.28c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J",
    className: "cls-6-VAE-P2",
    d: "m191.51,421.79v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K",
    className: "cls-6-VAE-P2",
    d: "m202.03,424.3c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    className: "cls-6-VAE-P2",
    d: "m216.77,424.3c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D-2",
    "data-name": "D",
    className: "cls-6-VAE-P2",
    d: "m231.57,427.77c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    className: "cls-6-VAE-P2",
    d: "m241.62,420.43c5.7,0,7.54,6.59,3.06,9.03-1.29.68-2.51,1.63-2.65,3.53h-2.1c0-4.28,5.23-3.73,5.23-7.74,0-2.04-1.43-2.85-3.53-2.92-2.17,0-3.6,1.15-3.8,3.12l-2.17-.14c.48-3.06,2.31-4.89,5.98-4.89Zm-1.77,17.04v-2.38h2.31v2.38h-2.31"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-VAE-P2",
    d: "m456.03,404.73l-.08,1-.23,1-.4.94-.53.88-.66.77-.78.66-.87.55-.93.4-1,.23-1,.07h-109.5v-1h109.47l.88-.06.84-.22.8-.33.73-.45.65-.56.56-.65.46-.75.33-.8.2-.84.06-.87v-156.16h1v156.19Zm-5.48-354l1,.25.93.4.88.52.78.67.66.78.54.87.4.94.22,1,.08.98v162.07h-1V57.18l-.07-.88-.2-.84-.34-.8-.45-.73-.55-.66-.66-.55-.74-.45-.8-.33-.84-.2-.88-.07h-87.72v-1h87.76l1,.06Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-VAE-P2",
    d: "m340.04,411.21h-.56l.06-.5-.05-.5h.57l-.02,1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-VAE-P2",
    d: "m340.07,411.24h-.62l.06-.53-.06-.52h.62v1.05Zm-.57-1l.06.47-.07.48h.52v-.95h-.51Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-VAE-P2",
    d: "m361.29,55.8l-14.26-4.64,14.26-4.63v9.27Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-VAE-P2",
    d: "m361.79,56.49l-16.38-5.33,16.38-5.32v10.65Zm-13.14-5.33l12.14,3.95v-7.9l-12.14,3.95Z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "N",
    className: "cls-10-VAE-P2",
    d: "m450.14,238.77l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "cls-10-VAE-P2",
    d: "m464.33,221.72c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56Zm0,15.41c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-VAE-P2",
    d: "m.51,171.76c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-86.67Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "P",
    className: "cls-9-VAE-P2",
    d: "m71.98,220.29l-1.73-4.44h-6.98l-1.73,4.44h-2.16l6.23-15.31h2.35l6.11,15.31h-2.1Zm-2.35-6.11l-2.9-7.59c-.74,2.78-1.91,5.06-2.84,7.59h5.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o-2",
    "data-name": "o",
    className: "cls-9-VAE-P2",
    d: "m81.17,210.23c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q",
    className: "cls-9-VAE-P2",
    d: "m85.13,217.39c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    className: "cls-9-VAE-P2",
    d: "m100.37,220.29h-2.22l-2.47-10.12-2.53,10.12h-2.22l-3.33-11.73h1.98l2.41,10.12,2.65-10.12h2.1l2.53,10.12,2.59-10.12h1.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    className: "cls-9-VAE-P2",
    d: "m109.82,208.31c3.83-.06,5.25,2.28,5.25,6.11.06,3.89-1.67,6.11-5.31,6.11s-5.12-2.41-5.19-6.11c0-4.07,1.73-6.11,5.25-6.11Zm-.06,10.74c2.72.06,3.27-1.91,3.27-4.63s-.49-4.63-3.15-4.63-3.27,1.98-3.27,4.63.62,4.57,3.15,4.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o-3",
    "data-name": "o",
    className: "cls-9-VAE-P2",
    d: "m123.03,210.23c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "cls-9-VAE-P2",
    d: "m132.16,220.29l-3.95-5.37-1.42,1.17v4.2h-1.98v-16.11h1.98v10.06l5.12-5.68h2.28l-4.75,5.06,5.06,6.67h-2.35"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "U",
    className: "cls-9-VAE-P2",
    d: "m142.47,204.98c5.37.06,11.79-.93,11.79,4.63,0,4.81-4.75,4.94-9.75,4.69v5.99h-2.04v-15.31Zm2.04,7.72c3.52,0,7.65.68,7.65-3.09s-4.2-2.9-7.65-2.96v6.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    className: "cls-9-VAE-P2",
    d: "m157.29,204.98c7.28-.43,13.33.49,13.15,7.53-.19,4.81-2.65,7.78-7.47,7.78h-5.68v-15.31Zm2.04,13.64c5.49.49,9.01-.99,9.01-6.11s-3.7-6.23-9.01-5.86v11.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    className: "cls-9-VAE-P2",
    d: "m175.31,206.71v5.68h8.52v1.73h-8.52v6.17h-2.04v-15.31h10.8v1.73h-8.77"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "V-2",
    "data-name": "V",
    className: "cls-9-VAE-P2",
    d: "m192.96,204.98c7.28-.43,13.33.49,13.15,7.53-.19,4.81-2.65,7.78-7.47,7.78h-5.68v-15.31Zm2.04,13.64c5.49.49,9.01-.99,9.01-6.11s-3.7-6.23-9.01-5.86v11.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-2",
    "data-name": "q",
    className: "cls-9-VAE-P2",
    d: "m213.27,208.31c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05Zm3.21,5c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X",
    className: "cls-9-VAE-P2",
    d: "m220.93,220.29v-16.11h1.98v16.11h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p-3",
    "data-name": "p",
    className: "cls-9-VAE-P2",
    d: "m225.8,206.03v-1.85h1.98v1.85h-1.98Zm0,14.26v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    className: "cls-9-VAE-P2",
    d: "m235.87,220.29h-2.35l-4.26-11.73h2.1l3.33,10.19,3.46-10.19h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-3",
    "data-name": "q",
    className: "cls-9-VAE-P2",
    d: "m246.48,208.31c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05Zm3.21,5c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o-4",
    "data-name": "o",
    className: "cls-9-VAE-P2",
    d: "m259.69,210.23c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-4",
    "data-name": "q",
    className: "cls-9-VAE-P2",
    d: "m266.17,208.31c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05Zm3.21,5c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z",
    className: "cls-9-VAE-P2",
    d: "m277.59,208.31c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17Zm.56,1.48c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "rect3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8-VAE-P2",
    d: "m.51,597.42c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v92c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-92Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "cls-9-VAE-P2",
    d: "m112.22,636.62c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "cls-9-VAE-P2",
    d: "m129.6,645.72c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-2",
    "data-name": "ab",
    className: "cls-9-VAE-P2",
    d: "m143.18,645.72c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "cls-9-VAE-P2",
    d: "m152.62,632.14c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84Zm3.53,8.22c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "cls-9-VAE-P2",
    d: "m175.03,638.32c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "cls-9-VAE-P2",
    d: "m191.19,646.67c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17Zm-3.26.2c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af",
    className: "cls-9-VAE-P2",
    d: "m205.04,639.61c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-3",
    "data-name": "ab",
    className: "cls-9-VAE-P2",
    d: "m221.88,645.72c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "cls-9-VAE-P2",
    d: "m238.38,640.36c2.31.27,3.8,1.43,4.01,3.94.48,6.18-10.05,6.38-11.68,1.9-.27-.61-.41-1.15-.48-1.77l3.46-.34c.07,1.63,1.09,2.38,2.72,2.44,1.56,0,2.65-.81,2.58-2.44-.07-2.1-2.1-2.44-4.41-2.31v-2.72c2.17.14,4.01-.2,4.01-2.24,0-1.36-.88-2.24-2.31-2.24s-2.24.88-2.38,2.17l-3.4-.2c.41-2.99,2.51-4.62,5.84-4.62s5.64,1.36,5.64,4.48c0,2.38-1.49,3.53-3.6,3.94"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-VAE-P2",
    d: "m171.64,265.43v45.47"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-VAE-P2",
    d: "m172.14,265.44h-1v-.5h1v.5Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-VAE-P2",
    d: "m171.64,325.66l-4.64-14.26h9.27l-4.63,14.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaePhase2);
export default __webpack_public_path__ + "static/media/VAE_Phase_2.bc8ce291c06ccdf7b6bca1055ecdee85.svg";
export { ForwardRef as ReactComponent };